module.exports = [{
      plugin: require('/home/ec2-user/api/wtl-project-starter/build.35b3cb4f-7580-4ab2-8318-0cbe79ad44be/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
